import { useEffect, useRef } from 'react';
import type { ChatMessage } from '@/types';
import { MessageBubble } from './MessageBubble';
import { TypingIndicator } from './TypingIndicator';

const GREETING: ChatMessage = {
  id: '__greeting__',
  role: 'assistant',
  content:
    'Willkommen! Ich bin dein Begleiter auf der Reise zu deinem inneren Team.\n\n' +
    'Das innere Team ist ein Modell von Friedemann Schulz von Thun: Jeder Mensch trägt verschiedene innere Stimmen und Anteile in sich – wie ein Team, das manchmal harmonisch zusammenarbeitet und manchmal im Widerstreit liegt.\n\n' +
    'Womit möchtest du beginnen? Gibt es eine Situation, eine Entscheidung oder ein inneres Hin-und-Her, das dich gerade beschäftigt?',
  timestamp: new Date().toISOString(),
};

interface Props {
  messages: ChatMessage[];
  isStreaming: boolean;
  greeting?: ChatMessage;
}

export function ChatWindow({ messages, isStreaming, greeting = GREETING }: Props) {
  const bottomRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages, isStreaming]);

  const displayMessages = messages.length === 0 ? [greeting] : messages;

  return (
    <div className="flex-1 overflow-y-auto py-4 space-y-1">
      {displayMessages.map((msg) => (
        <MessageBubble key={msg.id} message={msg} />
      ))}
      {isStreaming && <TypingIndicator />}
      <div ref={bottomRef} />
    </div>
  );
}
